// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Node extends TrackingModel {
	public NodeId: number = 0;
	public ParentNodeId?: number;
	public Name: string = "";
	public Description?: string;
	public DisplayText: string = "";
	public ShortDisplayText?: string;
	public Route: string = "";
	public SortOrdinal?: number;
	public IconName?: string;
	public IconOverrideImagePath?: string;
}